import React from 'react';

const SvgUp = (props) => (
  <svg width={8} height={10} {...props}>
    <path
      fill="#6CC89F"
      fillRule="evenodd"
      stroke="#6CC89F"
      strokeWidth={0.5}
      d="M3.514 9.271l.072-7.696-2.249 2.248-.417-.417L3.894.433 6.812 3.35l-.425.425-2.206-2.207-.072 7.7z"
    />
  </svg>
);

export default SvgUp;
